import React from 'react';

const ProductCardPlaceholder = () => {
  return (
    <div className="flex flex-col bg-white rounded-none p-2.5 max-h-[calc(100%_-_4px)] w-full min-w-0 md:p-4">
      <div className="w-full h-auto aspect-square bg-gray-200 skeleton"></div>
      <div className="flex flex-col basis-0 h-full pt-3 justify-between flex-1">
        <div className="flex flex-col gap-2 mb-2">
          <div className={`h-8 bg-gray-200 rounded-0.5`}>&nbsp;</div>
          <div className={`h-4 max-w-[75%] bg-gray-200 rounded-0.5`}>
            &nbsp;
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <div className="max-w-[80px] bg-gray-200 rounded-0.5">&nbsp;</div>
          <div className="max-w-[32px] bg-gray-200 rounded-0.5">&nbsp;</div>
          <div className="max-w-[56px] bg-gray-200 rounded-0.5">&nbsp;</div>
        </div>
      </div>
    </div>
  );
};

export default ProductCardPlaceholder;
